import React, { useEffect, useState } from 'react'
import {
  Avatar,
  Button,
  Divider,
  Form,
  Input,
  List,
  Popconfirm,
  Spin,
  Typography
} from 'antd'
import { DeleteOutlined, EditOutlined, UserOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import get from 'lodash.get'
import {
  listNote,
  noteAdd,
  noteDelete,
  noteUpdate
} from '../../services/data-customer-service'
import openNotification from '../common/Notification/openNotification '

const { Text } = Typography

const Note = ({ bookingId }) => {
  const [form] = Form.useForm()
  const [comments, setComments] = useState([])
  const [editingId, setEditingId] = useState(null)
  const [loading, setLoading] = useState(false)

  const getListNote = async () => {
    if (!bookingId) return
    setLoading(true)
    try {
      const res = await listNote({
        target_id: bookingId,
        target_type: 'BOOKING_POST'
      })
      setComments(res?.data?.list || [])
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getListNote()
  }, [bookingId])

  const handleSubmit = async (values) => {
    try {
      const body = {
        ...values,
        target_type: 'BOOKING_POST',
        target_id: bookingId
      }
      const res =
        editingId !== null
          ? await noteUpdate(body, editingId)
          : await noteAdd(body)

      openNotification('success', res?.message || 'Thành công')
      setEditingId(null)
      form.resetFields()
      getListNote()
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handleDelete = async (id) => {
    try {
      const res = await noteDelete({ ids: [id] }, id)
      openNotification('success', res?.message || 'Thành công')
      getListNote()
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const handleEdit = (comment) => {
    setEditingId(comment.id)
    form.setFieldsValue({ note: comment.note })
  }

  return (
    <div style={{ maxWidth: '100%', padding: '0 16px' }}>
      <Divider>Danh sách note</Divider>
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="note"
          rules={[{ required: true, message: 'Nhập bình luận!' }]}
        >
          <Input.TextArea rows={3} placeholder="Viết bình luận..." />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          {editingId !== null ? 'Cập nhật' : 'Thêm Note'}
        </Button>
      </Form>

      {loading ? (
        <Spin tip="Đang tải bình luận..." style={{ marginTop: 20 }} />
      ) : (
        <div style={{ maxHeight: 360, overflow: 'auto', marginTop: 20 }}>
          <List
            dataSource={comments}
            locale={{ emptyText: 'Không có note' }}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <EditOutlined key="edit" onClick={() => handleEdit(item)} />,
                  <Popconfirm
                    key="delete"
                    title="Xóa bình luận?"
                    onConfirm={() => handleDelete(item.id)}
                  >
                    <DeleteOutlined style={{ color: 'red' }} />
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta
                  avatar={<Avatar icon={<UserOutlined />} />}
                  title={
                    <Text strong>
                      {item?.user_created}
                      <Text type="secondary" style={{ marginLeft: 10 }}>
                        {item?.created_at
                          ? dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss')
                          : ''}
                      </Text>
                    </Text>
                  }
                  description={item?.note}
                />
              </List.Item>
            )}
          />
        </div>
      )}
    </div>
  )
}

export default Note
